/* eslint-disable dot-notation */
import { Order } from 'blockly/javascript'

export function registerLogicGenerators(gen) {
  gen.forBlock['logic_if'] = function (block, generator) {
    const cond = generator.valueToCode(block, 'COND', Order.NONE) || 'false'
    const branch = generator.statementToCode(block, 'DO') || ''
    return `if (${cond}) {\n${branch}}\n`
  }

  gen.forBlock['logic_if_else'] = function (block, generator) {
    const cond = generator.valueToCode(block, 'COND', Order.NONE) || 'false'
    const branchDo = generator.statementToCode(block, 'DO') || ''
    const branchElse = generator.statementToCode(block, 'ELSE') || ''
    return `if (${cond}) {\n${branchDo}} else {\n${branchElse}}\n`
  }

  gen.forBlock['logic_compare_equal'] = function (block, generator) {
    const a = generator.valueToCode(block, 'A', Order.ATOMIC) || '0'
    const b = generator.valueToCode(block, 'B', Order.ATOMIC) || '0'
    return [`${a} === ${b}`, Order.EQUALITY]
  }

  gen.forBlock['logic_compare_less'] = function (block, generator) {
    const a = generator.valueToCode(block, 'A', Order.ATOMIC) || '0'
    const b = generator.valueToCode(block, 'B', Order.ATOMIC) || '0'
    return [`${a} < ${b}`, Order.RELATIONAL]
  }

  gen.forBlock['logic_compare_greater'] = function (block, generator) {
    const a = generator.valueToCode(block, 'A', Order.ATOMIC) || '0'
    const b = generator.valueToCode(block, 'B', Order.ATOMIC) || '0'
    return [`${a} > ${b}`, Order.RELATIONAL]
  }

  gen.forBlock['logic_touching'] = (block) => {
    const sprite = block.getFieldValue('SPRITE') || 'batu'
    return [`isTouching('${sprite}')`, Order.FUNCTION_CALL]
  }
}
